export function initObserveNotLoadedImages() {
    const fallbackURL = '/layout/frontend/freundeskreis2025/dist/images/dummy.jpg'; // the replacement image URL
    const area = document.getElementById('communityTimeline');
    if(!area){
        return;
    }
    // Function to attach error listeners to <img> elements
    function watchImages(container) {
        container.querySelectorAll('img').forEach(img => {
            img.addEventListener('error', function handleError() {
                // Avoid infinite loop if fallback also fails
                if (img.dataset.replaced !== 'true') {
                    img.dataset.oldUrl = img.src;
                    img.src = fallbackURL;
                    img.dataset.replaced = 'true';
                }
            });
        });
    }

    // Initial load
    watchImages(area);

    // Watch for new images being added dynamically
    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            mutation.addedNodes.forEach(node => {
                if (node.tagName === 'IMG') {
                    watchImages(node.parentNode);
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    watchImages(node);
                }
            });
        }
    });

    observer.observe(area, { childList: true, subtree: true });
}